import { FadeUp, SectionTag } from "@/components/motion";
import { ManifestoChapter } from "@/components/ManifestoChapter";

const CHAPTERS = [
  {
    n: "01",
    title: "Selection & Fit",
    body: "Choose your chain. Sterling Silver, Gold Filled, or Enamel. Measured to the fit you are most comfortable with.",
  },
  {
    n: "02",
    title: "The Precision Spark",
    body: "A quick, painless pulse of light welds the chain closed. No clasp, no catch — just a seamless circle that is yours alone.",
  },
  {
    n: "03",
    title: "The Eternal Bond",
    body: "Walk out forever linked. Shower, swim, sweat — your piece stays with you through every chapter, until you decide its story is done.",
  },
];

const WELD_IMG = "/images/manifesto-chains.jpg";

export default function Manifesto() {
  return (
    <section id="story" data-testid="manifesto-section" className="py-20 sm:py-28 lg:py-36 bg-white text-ink relative overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute top-10 right-0 font-serif italic text-[18vw] leading-none text-ink/[0.04] select-none whitespace-nowrap"
      >
        ritual
      </div>
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto relative">
        <FadeUp className="max-w-2xl mb-16 sm:mb-24">
          <SectionTag>The Welded Experience</SectionTag>
          <h2 className="mt-3 font-serif tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight">
            Three small moments.<br />
            <span className="italic text-gold">One permanent one.</span>
          </h2>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {CHAPTERS.map((c, i) => (
            <ManifestoChapter key={c.n} chapter={c} index={i} />
          ))}
        </div>

        <FadeUp delay={0.2} className="mt-16 sm:mt-24">
          <div className="relative overflow-hidden rounded-[2rem]">
            <img
              src={WELD_IMG}
              alt="Jeweller precision-welding a fine gold chain"
              loading="lazy"
              data-testid="manifesto-image"
              className="w-full h-64 sm:h-96 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/20 to-transparent" />
            <p className="absolute left-6 sm:left-12 bottom-6 sm:bottom-10 max-w-sm font-serif italic text-xl sm:text-2xl text-alabaster leading-snug">
              "A beautiful outer symbol of your unique inner journey."
            </p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
